// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { RootState } from '~/utils/redux/store';
import { createCategory, deleteCategory, getDetailCategory, getListCategory, updateCategory } from './categoryThunk';

export interface ICategoryState {
  isLoading: boolean;
  isRefreshCategoryList: boolean;
}

export const initialState: ICategoryState = {
  isLoading: false,
  isRefreshCategoryList: false,
};

const categorySlice = createSlice({
  name: 'category',
  initialState,
  reducers: {
    setRefreshCategoryList(state, action) {
      state.isRefreshCategoryList = action.payload;
    },
  },
  extraReducers(builder) {
    // GET: Get list category
    builder
      .addCase(getListCategory.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getListCategory.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(getListCategory.rejected, (state) => {
        state.isLoading = false;
      });

    // GET: Get detail category
    builder
      .addCase(getDetailCategory.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDetailCategory.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(getDetailCategory.rejected, (state) => {
        state.isLoading = false;
      });

    // POST: Create category
    builder
      .addCase(createCategory.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createCategory.fulfilled, (state) => {
        state.isLoading = false;
        state.isRefreshCategoryList = true;
      })
      .addCase(createCategory.rejected, (state) => {
        state.isLoading = false;
      });

    // DELETE: Delete category
    builder
      .addCase(deleteCategory.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteCategory.fulfilled, (state) => {
        state.isLoading = false;
        state.isRefreshCategoryList = true;
      })
      .addCase(deleteCategory.rejected, (state) => {
        state.isLoading = false;
      });

    // PUT: Update category
    builder
      .addCase(updateCategory.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateCategory.fulfilled, (state) => {
        state.isLoading = false;
        state.isRefreshCategoryList = true;
      })
      .addCase(updateCategory.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

// Action
export const categoryActions = categorySlice.actions;

// Selectors
export const selectIsRefreshListCategory = (state: RootState) => state.category.isRefreshCategoryList;

// Reducer
const categoryReducer = categorySlice.reducer;
export default categoryReducer;
